
































































































































import * as firebase from "firebase";
import 'firebase/firestore';
import Firestore = firebase.firestore.Firestore;
import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator";
import { LiveStreamingParam } from "@/params/LiveStreamingParam";
import EmbedYoutubePlayer from "@/components/media/EmbedYoutubePlayer.vue";
import LiveStreamingCommentsUnit from "@/components/vr-live/LiveStreamingCommentsUnit.vue";
import { UserComment } from "@/params/User";
import vuescroll from 'vuescroll';
import ImagePreloader from "@/media/ImagePreloader";
import LiveStreamingCustomOverlay from "@/components/vr-live/LiveStreamingCustomOverlay.vue";
import LoadingScreen from "@/components/atom/LoadingScreen.vue";


@Component({
  components: {
    LoadingScreen,
    LiveStreamingCustomOverlay,
    LiveStreamingCommentsUnit,
    EmbedYoutubePlayer,
    vuescroll
  }
})
export default class VrLiveStreaming extends Vue {
  /* DOM */
  private $liveVideoArea: HTMLDivElement;
  private $smpVideoArea: HTMLDivElement;

  /* Data */
  private isYtPlayerOpen: boolean = false;
  private isCommentUnitShow: boolean = false;
  private isCustomOverlayImage: boolean = false;
  private isShownLoading: boolean = false;
  // Image Loader
  private imagePreloader: ImagePreloader;
  // イメージの読み込みが完了したかどうか
  private isLoadedImages: boolean = false;
  // ディスクイメージ画像のURL
  private discImageUrl: string = '';
  // 背景オーバーレイ画像のURL
  private overlayImageUrl: string = '';
  // Firestore Database
  private db: Firestore = null;
  // 読み込んだ（Firebaseのコレクションとコネクトしたコメントデータ
  private userComments: UserComment[] = [];
  // コメントの読込中かどうか
  private isLoadingComments: boolean = false;
  // コメントを送信中かどうか
  private isSendingComments: boolean = false;
  // コメントエリアのスクロールバーの設定オプション
  private scrollOptions: any = {
    vuescroll: {
      detectResize: true
    },
    bar: {
      background: '#8A56AC'
    }
  };
  // ビデオプレイヤーの幅
  private videoPlayerWidth: string = '300px';
  private smpCommentsAreaHeight: string = '100%';

  private liveContentsList: LiveStreamingParam[] = [
    {
      contentNo: 1,
      artist: 'Sky News',
      actTitle: 'Watch Sky News live',
      discImageUrl: '/images/stagepoint_cd3.png',
      ytVideoId: '9Auq9mYxFEE',
      commentsDataCollection: '/VR-Live-Space/comments/stage0'
    },
    {
      contentNo: 2,
      artist: 'SPACE (Official)',
      actTitle: 'WATCH NASA: Astronaut Spacewalk #RealTimeTracker LIVE NASA FEED',
      discImageUrl: '/images/stagepoint_cd1.png',
      overlayImage: '/images/LiveStreaming-Image01.png',
      ytVideoId: 'DDU-rZs-Ic4',
      commentsDataCollection: '/VR-Live-Space/comments/stage1',
    },
    {
      contentNo: 3,
      artist: 'Explore Africa',
      actTitle: 'Africam Tembe Elephant Park<br />powered by EXPLORE',
      discImageUrl: '/images/stagepoint_cd2.png',
      overlayImage: '/images/LiveStreaming-Image02.png',
      ytVideoId: '48MFrf5ADp8',
      commentsDataCollection: '/VR-Live-Space/comments/stage2',
    }
  ];
  private contents: LiveStreamingParam = null;


  /* Property */
  // ライブストリーミングコンテンツを表示する
  @Prop() isOpen: boolean;
  // 表示するコンテンツ番号
  @Prop() contentNo: number;

  /* Watcher */
  /**
   * コンテンツ番号を監視し変更があれば使用するコンテンツを差し替える
   */
  @Watch('contentNo')
  onChangeContentsNo (newValue, oldValue) {
    if (newValue) {
      this.liveContentsList.some(liveContents => {
        if (newValue === liveContents.contentNo) {
          this.contents = liveContents;
          return true;
        }
      });
    }
    else {
      // contentsNoをnullにセットするとすべてのコンテンツをリセットし空の状態にする
      console.log('Reset Live Contents');
      this.isLoadedImages = false;
      this.discImageUrl = '';
      this.overlayImageUrl = '';
      // コンテンツを空にする
      this.contents = null;
    }
  }

  /**
   * 表示プロパティを監視し、表示が実行された場合に画像読み込みを開始する
   * 外から表示プロパティがfalseに設定されても非表示プロセスは実行されない
   * 必ずisShownDrawer算出プロパティをfalseにすることで非表示プロセスが実行される
   */
  @Watch('isOpen')
  onOpenContents (newValue, oldValue) {
    if (newValue) {
      // スマホレイアウト時はそのまま表示させるだけ
      if (this.isSmp) {
        this.isLoadedImages = true;
        return;
      }

      console.log('Load Images Start');
      console.log(this.contents);
      // ローディング表示スタート
      this.isShownLoading = true;
      if (!this.imagePreloader) {
        this.imagePreloader = new ImagePreloader();
      }
      // 画像リストの作成
      const images: string[] = [];
      let discImage: string = '';
      let overlayImage: string = '';
      if (this.contents.discImageUrl) {
        // ディスクイメージをリストに格納
        discImage = this.$store.state.publicPath + this.contents.discImageUrl;
        images.push(discImage);
      }
      if (this.contents.overlayImage) {
        // 背景オーバーレイイメージをリストに格納
        overlayImage = this.$store.state.publicPath + this.contents.overlayImage;
        console.log('Overlay Image: ' + overlayImage);
        images.push(overlayImage);
      }

      // イメージが存在しなければそこで終了
      if (images.length <= 0) {
        this.isLoadedImages = true;
        return;
      }

      // イメージの読み込み
      this.imagePreloader.load(images)
        .then((result) => {
          console.log('Load Images Complete');
          // 各イメージのURLを反映する
          this.discImageUrl = discImage;
          this.overlayImageUrl = overlayImage;
          // 1秒待機
          setTimeout(() => {
            this.isLoadedImages = true;
            // ローディング表示をOFFに
            this.isShownLoading = false;
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
          this.isShownLoading = false;
          this.isLoadedImages = true;
        });
    }
  }

  /* Emit Events */
  @Emit('open-contents')
  emitOpenContents (): void {}

  @Emit('close-contents')
  emitCloseContents ():void {}

  /* Computed Property */
  /**
   * カスタムのオーバーレイイメージ画像が指定されていた時にその表示スタイルを取得する
   */
  get customOverlayStyle (): any {
    return {
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
      backgroundImage: `url(${this.overlayImageUrl})`
    };
  }

  /**
   * 表示・非表示トリガーとして機能する算出プロパティ
   * isOpenフラグがONになると監視メソッド内で画像読み込みがスタートする
   * 画像が読み込み終わりisLoadedImagesフラグがONになった場合にtrueを返す
   */
  set isShownDrawer (value: boolean) {
    console.log('updateDrawer: ', value);
    if (value) {
      if (this.overlayImageUrl && this.overlayImageUrl !== '') {
        this.isCustomOverlayImage = true;
      }
      this.setVideoWidth();
      this.setSmpCommentsAreaHeight();
      this.isYtPlayerOpen = true;
      // ここでコメント一覧のデータの読み込み開始
      this.isCommentUnitShow = true;
      this.initializeComments();
      this.emitOpenContents();
    }
    else {
      // コンテンツを非表示にする
      this.isYtPlayerOpen = false;
      this.isCommentUnitShow = false;
      this.isCustomOverlayImage = false;
      // コメント欄をリセット
      this.resetComments();
      this.emitCloseContents();
    }
  }
  get isShownDrawer (): boolean {
    // 既に必要な画像が読み込み済みのときにフラグがONになる
    return (this.isOpen && this.isLoadedImages);
  }

  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }


  /* Lifecycle Hook */
  mounted (): void {
    this.$nextTick(() => {
      if (!this.isSmp) {
        this.$liveVideoArea = <HTMLDivElement> this.$refs.liveVideoArea;
        this.setVideoWidth();
      }
    });
  }

  /* Event Handler */
  private onClickClose (ev: MouseEvent): void {
    this.isShownDrawer = false;
  }


  /* Methods */
  private initializeComments (): void {
    console.log('===========> Load Live Comments');
    this.userComments = [];

    if (!this.db) {
      this.db = firebase.firestore();
      console.log('===========> Create Firestore Object');
    }

    this.loadAndUpdateComments();
  }

  private loadAndUpdateComments (): void {
    this.isLoadingComments = true;
    this.isSendingComments = true;

    const commentsRef = this.db.collection(this.contents.commentsDataCollection);
    commentsRef.orderBy('timestamp', 'desc').get().then((snapshot) => {
      // コメントリストを空にする
      console.log('Comment Amount: ' + snapshot.size);
      snapshot.forEach((doc) => {
        const commentData: UserComment = <UserComment> doc.data();
        this.userComments.push(commentData);
      });
      this.isLoadingComments = false;
      this.isSendingComments = false;
    })
    .catch((err) => {
      this.isLoadingComments = false;
      this.isSendingComments = false;
      console.log(err);
    });

    // データベースの更新を検知する
    commentsRef.orderBy('timestamp', 'desc').onSnapshot((querySnapshot) => {
      this.userComments = [];
      console.log('Comment Update: ' + querySnapshot.size);
      querySnapshot.forEach((doc) => {
        const commentData: UserComment = <UserComment> doc.data();
        this.userComments.push(commentData);
      });
    });
  }

  /**
   * ビデオプレイヤーの幅をセットする
   */
  private setVideoWidth (): void {
    if (!this.$liveVideoArea) {
      this.videoPlayerWidth = '80%';
      return;
    }
    // 閉じるボタンが配置されるので、高さは実際のエリアより80px狭く考慮する
    const offsetH: number = 140;
    const areaW: number = this.$liveVideoArea.clientWidth;
    const areaH: number = this.$liveVideoArea.clientHeight - offsetH;
    const maxVideoW: number = areaW * 0.8; // エリアの幅の90%がプレイヤーの最大サイズ
    const maxVideoH: number = maxVideoW * 0.5625;
    // ビデオエリアの高さよりも最大ビデオ高の方が小さい場合
    if (maxVideoH <= areaH) {
      this.videoPlayerWidth = String(Math.floor(maxVideoW)) + 'px';
    }
    // ビデオエリアに最大ビデオ高が収まらない場合
    else {
      // 実際のビデオ高を元に最大高からの縮小率を求める
      const scale: number = areaH / maxVideoH;
      // 求めた縮小率からビデオの幅を求める
      const videoW: number = Math.floor(maxVideoW * scale);
      this.videoPlayerWidth = String(videoW) + 'px';
    }
  }

  private setSmpCommentsAreaHeight (): void {
    this.$smpVideoArea = <HTMLDivElement> this.$refs.smpVideoArea;
    console.log('Video Area: ', this.$smpVideoArea);
    if (this.$smpVideoArea) {
      console.log('Viewport Height: ' + document.body.clientHeight);
      const videoHeight: number = document.body.clientWidth * 0.5625;
      console.log('Video Area Height: ' + videoHeight);
      const commentsHeight = document.body.clientHeight - videoHeight;
      this.smpCommentsAreaHeight = commentsHeight + 'px';
    }
  }


  private onSubmitComment (submitData: any): void {
    this.isSendingComments = true;
    this.getCommentsId()
    .then((cid) => {
      // コメントを追加する
      const commentData: UserComment = {
        cid: cid,
        name: submitData.username,
        commentText: submitData.commentText,
        thumbnailUrl: submitData.thumbnailUrl,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      };

      const commentsCollection = this.db.collection(this.contents.commentsDataCollection);
      commentsCollection.add(commentData)
      .then((docRef) => {
        console.log('Comment Add: ' + docRef.id);
        // セクションIDを更新する
        this.updateCommentsSequence(cid)
        .then((result) => {
          console.log('Update Sequence => ' + cid);
          console.log('Success Add Comments');
          this.isSendingComments = false;
        })
        .catch((err) => {
          console.log(err);
        });
      })
      .catch((err) => {
        console.log(err);
      });
    })
    .catch((err) => {
      console.log(err);
    });
  }


  private resetComments (): void {
    this.isLoadingComments = false;
    this.isSendingComments = false;
    const unsubscribe = this.db.collection(this.contents.commentsDataCollection).onSnapshot(() => {});
    unsubscribe();
    this.userComments = [];
  }


  private async getCommentsId (): Promise<any> {
    return new Promise((resolve, reject) => {
      const commentsRef = this.db.doc('/VR-Live-Space/comments');
      commentsRef.get()
      .then((snapshot) => {
        const seq: number = snapshot.get('seq');
        // インクリメントした数字がコメントのIDになる
        resolve(seq + 1);
      })
      .catch((err) => {
        reject(err);
      });
    });
  }

  private async updateCommentsSequence (seq: number): Promise<any> {
    return new Promise((resolve, reject) => {
      const commentsRef = this.db.doc('/VR-Live-Space/comments');
      commentsRef.update({seq: seq})
      .then((res) => {
        resolve(0);
      })
      .catch((err) => {
        reject(err);
      });
    })
  }
}
